module.exports = __webpack_public_path__ + "static/media/rocket_white.d9fb13a2.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/icons/rocket_white.svg
// module id = 2232
// module chunks = 0